import { render, staticRenderFns } from "./UnterrichtWidgetForm.vue?vue&type=template&id=2d38044e&scoped=true"
import script from "./UnterrichtWidgetForm.vue?vue&type=script&lang=ts"
export * from "./UnterrichtWidgetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38044e",
  null
  
)

export default component.exports